import { render } from "./PublicLinksSection.vue?vue&type=template&id=5a475e61&scoped=true"
import script from "./PublicLinksSection.vue?vue&type=script&lang=js"
export * from "./PublicLinksSection.vue?vue&type=script&lang=js"

import "./PublicLinksSection.vue?vue&type=style&index=0&id=5a475e61&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a475e61"]])

export default __exports__